// Central home for Cognito role groups the app has business logic for.
// Named constants only — no runtime logic. Import these instead of
// hard-coding role strings at call sites.
//
// Migration note: bare group strings ("admin", "roadmin", "beta", "internal")
// and ROLE_JOURNEY_MANAGER_BETA_USER (currently in CurrentUserSessionHelper)
// should move here over time. Only the Polly roles live here today.

export const ROLE_POLLY_RESEARCH_MANAGER = "ROLE_polly_research_manager";
export const ROLE_POLLY_CRAWL_SOURCE_MANAGER = "ROLE_polly_crawl_source_manager";

// Temporary: hides the Klaviyo entry points while the integration is piloted with
// selected clients. Remove this constant and its call sites at general availability.
export const ROLE_KLAVIYO_BETA_USER = "ROLE_klaviyo_beta_user";
